export default hasNamedExports;

function hasNamedExports(mod) {
	var i = mod.exports.length;

	while (i--) {
		if (!mod.exports[i].isDefault) {
			return true;
		}
	}
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/hasNamedExports.js.01-babel.map